var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGoogleChromeLogo = function SvgIconGoogleChromeLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2 12c0-2.291.77-4.402 2.066-6.088a1 1 0 0 1 .104-.133A9.98 9.98 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10a10 10 0 0 1-1.44-.103C5.72 21.199 2 17.034 2 12m10-8c-2.323 0-4.415.99-5.877 2.572l1.982 3.434A4.38 4.38 0 0 1 12 7.625h6.699A8 8 0 0 0 12 4m.443 15.988a8 8 0 0 0 7.199-10.363h-3.967c.443.684.7 1.5.7 2.375a4.36 4.36 0 0 1-.584 2.187zm-.22-3.619-1.984 3.437a8.003 8.003 0 0 1-5.378-11.42l3.348 5.801.027.044a4.37 4.37 0 0 0 3.986 2.138M12 9.625a2.375 2.375 0 1 0 0 4.75 2.375 2.375 0 0 0 0-4.75",
    clipRule: "evenodd"
  })));
};
export default SvgIconGoogleChromeLogo;